<template>
  <div class="login">
    <Title titleName='商家中心' iconLeft="back"/>
	

	<div class="mem-con">
		<div class="mem-l1">
			<van-row>
				<van-col span='6'>
					<img class="head" :src="user.avatar" />
				</van-col>
				<van-col span='14'>
					<h3> {{user.store_name}}</h3>
					<p>手机：{{user.store_phone}}</p>
				
				</van-col>
			
			</van-row>
		
		</div>
	
		

	</div>
	
	<div class="mem-l2">
				<div class="tit">
					<h3>我的订单</h3>
				
				</div>
				<ul>
					
					<li><router-link to="comment?id=3">
						<img src="../../assets/icon2.png" />
						<p>待出票</p></router-link>
					</li>
					<li><router-link to="comment?id=4">
						<img src="../../assets/icon3.png" />
						<p>已出票</p></router-link>
					</li>
				
				</ul>
			</div>
			<div class="card-color">
				<div class="leaf">
					<div class="dont">
						<img src="../../assets/dr1.png" />接单模式
					</div>
				
					<div class="fit">
						<van-switch size="22" v-model="user.store_info.taking_mode" @change="mode" active-color="#FF5E00" inactive-color="#dcdee0" />
						
					</div>
				</div>
				<div class="leaf">
					<router-link to="inter">
						<div class="dont">
							<img src="../../assets/dr2.png" />自动报价
						</div>
						<div class="fit">
							<img src="../../assets/ip.png" />
							
						</div>
					</router-link>
					
				</div>
				<div class="leaf">
					<router-link to="exc">
						<div class="dont">
							<img src="../../assets/dr3.png" />我的钱包
						</div>
						<div class="fit">
							<img src="../../assets/ip.png" />
							
						</div>
					</router-link>
					
				</div>
				<div class="leaf">
					<div class="dont">
						<img src="../../assets/dr4.png" />出票率
					</div>
					<div class="fit">
					{{user.store_info.draw_rate}}%
						
					</div>
				</div>
				<div class="leaf">
					<div class="dont">
						<img src="../../assets/dr5.png" />出票时间
					</div>
					<div class="fit">
					{{user.store_info.mean_time}}分钟
						
					</div>
				</div>
				<div class="leaf">
					<div class="dont">
						<img src="../../assets/dr6.png" />手机号
					</div>
					<div class="fit">
					{{user.store_phone}}
						
					</div>
				</div>
			
				<div class="leaf" @click="leaf">
					
						<div class="dont">
							<img src="../../assets/dr7.png" />清空缓存
						</div>
						<div class="fit">
							<img src="../../assets/ip.png" />
							
						</div>
					
					
				</div>
			</div>
	
	
	
	 
  </div>
</template>
<script>
import Title from "@/common/title";
import Bar from '@/components/bar/bar'
import { Toast } from 'vant';	
export default {
  components: {
    Title,
    Bar

  },
  data() {
    return {
		taking_mode:false,
		user:'',
		active: 1,
		id:'',
		file:'',
		ruleForm:{
			email:'',
			password:''
		}
    
    };
  },mounted() {
  	this.id = this.$route.query.id
this.sandMate();
  },methods:{
	  leaf(){
      let user = JSON.parse(window.localStorage.getItem('user'));
		  window.localStorage.clear();
      localStorage.setItem('user',JSON.stringify(user));
		  this.$router.push({ path: "/" });

	  },
	sandMate(){
		
		this.$axios({
		  method: "post",
		  url: "stores/info",
		  data: {},  
		}).then((res)=>{
		    let data=res.data;
		    let user = JSON.parse(window.localStorage.getItem('user'));
		    if(data.code==200){
		    	data.data.store_info.token=user.token
		    	localStorage.setItem('user',JSON.stringify(data.data.store_info))
		    	this.user=data.data.store_info
				if(data.data.store_info.store_info.taking_mode==1){
					this.user.store_info.taking_mode=false
				}else{
					this.user.store_info.taking_mode=true
				}
		    	
		    
		    }
		 })
	
	}, mode() {
				
	          this.$axios({
	            method: "post",
	            url: "stores/mode",
	            data: {taking_mode:this.taking_mode}
	          }).then((res) => {
	          	let data=res.data;
	          			
	          	if(data.code==200){
	  						
	  			  Toast(data.message);
				
	    
	          		
	          	}else{  
	  			 Toast(data.message);
	  						      
	  			}
	           
	          });
	  				 
	  				 
	         
	       
	       }
  }
};
</script>
<style lang="scss" scoped>
.login{
	
	h1{
	
		font-size: 32px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #FFFFFF;
		text-align: center;
		margin-bottom: 20px;

	}
}
 .pro-tit{
	 text-align: center;
	 line-height: 40px;
	 padding: 20px 0;
	 h3{
		 font-size: 36px;
	 }
	 p{
		 font-size: 24px;
	 }
 }
 .mem-con{
	 background: url(https://vkceyugu.cdn.bspapp.com/VKCEYUGU-dba7ffc8-6102-457c-8941-6212ed989b04/6c557c89-a107-489e-a719-2fb92b0fd379.png) no-repeat;
	 background-size: 100%;
	 font-size: 24px;
	 color: #fff;
	 padding: 30px;
	 .mem-l1{
	
		 padding: 40px 0;
		 h3{
			 margin: 15px 0;
			 font-size: 34px;
			 color: #fff;
		 }
		 .head{
			width:150px;
			border-radius: 150px;
		 }
		 .set{
			 width: 42px;
		 }
		 .shop{
			 width: 120px;
			 height: 36px;
			 border-radius: 18px;
			 color: #7D7D7D;
			 background: #fff;
			 text-align: center;
			 font-size: 24px;
			 margin-top: 15px;
		 }
		 .mem-sim{
			 text-align: center;
			 margin-top: 20px;
			 h4{
				 color: #fff;
				 font-size: 40px;
				 font-weight: normal;
			 }
			 p{
				 color: #fff;
			 }
		 }
		 
	 }
	
 }
 .mem-l2{
 		 background: #FFFFFF;
 		 padding: 30px;
		margin-bottom: 20px;
 		 .tit{
 			 display: flex;
 			 justify-content: space-between;
 			 h3{
 				 font-size: 30px;
 				 color: #000000;
 			 }
 			 p{
 				 display: flex;
 				 img{
 					 width: 30px;
 					 height: 30px;
 				 }
 			 }
 		 }
 		 ul{
 			 display: flex;
 			 li{
 				 width: 50%;
 				 text-align: center;
 				 padding: 30px 0;
 				 img{
 					 width: 56px;
 				 }
 			 }
 			
 		 }
 		 .min{
 		 				 li{
 		 					  width: 25%;
 		 				 }
 		 				
 		 }
 }
 .card-color{
	 background: #fff;
	 .leaf{
		 display: flex;
		 justify-content: space-between;
		 align-items: center;
		 border-bottom: 1px solid #eeeeee;
		 padding: 30px 0;
		 padding-right: 30px;
		 margin-left:30px;
		 height: 40px;
		 font-size: 28px;
		 color: #000000;
		 a{
			 display: flex;
			 justify-content: space-between;
			 align-items: center;
			 width: 100%;
			 color: #000000;
		 }
		 .dont{
			 display: flex;
			 align-items: center;
			 img{
				 width: 32px;
				 height: 32px;
				 margin-right: 15px;
			 }
		 }
		 .fit{
			 color: #999999;
			 img{
				 width: 30px;
				 height: 30px;
			 }
		 }
	 }
 }
</style>